import { Injectable, NgZone, DOCUMENT, inject } from '@angular/core';
import { GridFilterComponent } from 'app/shared/components/grid-filter/grid-filter.component';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FocusService {
  public focusOnAdvancedFilterPanelToggleButtonFlag: boolean;
  public focusOnCustomerPanelToggleButtonFlag: boolean;
  public focusOnLaboratoryResourcePanelToggleButtonFlag: boolean;
  public routerOutletLoaded = new Subject<void>();

  private _document = inject(DOCUMENT);
  private _ngZone = inject(NgZone);

  public routerOutletLoadedHandler(): Observable<void> {
    return this.routerOutletLoaded.asObservable();
  }

  public setFocusOnGridFilter($event: Event, gridFilter: GridFilterComponent): void {
    if (
      FocusService._isDescendant(this._getLeftFuseSideBar(), $event.target as HTMLElement) ||
      document.activeElement!.nodeName === 'BODY'
    ) {
      $event.preventDefault();
      gridFilter.setFocus();
    }
  }

  // https://lukeliutingchun.medium.com/angular-performance-issue-caused-by-settimeout-and-setinterval-1a4a65c07be3
  public setTimeoutOutsideAngular(actionFunction: () => void, ms = 0): void {
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        actionFunction();
      }, ms);
    });
  }

  private static _isDescendant(pParent: HTMLElement | null, pChild: HTMLElement): boolean {
    while (pChild !== null) {
      if (pChild === pParent) {
        return true;
      } else {
        pChild = pChild.parentNode as HTMLElement;
      }
    }

    return false;
  }

  private _getLeftFuseSideBar(): HTMLElement | null {
    return this._document.getElementById('left-fuse-sidebar');
  }
}
